import React, { useState } from "react";
import { Select, Input, Typography, Tooltip } from "antd";
import { SwapOutlined } from "@ant-design/icons";
import { useAuth } from "../../../../../contexts/auth";

const { Paragraph } = Typography;

const ReportedParameterCell = ({
  record,
  handleDataChange,
  getParameterOptions,
}) => {
   const auth = useAuth();
     const user = auth.loggedInUser;
    const userRole = user?.role;
  const [isSelect, setIsSelect] = useState(true);
  const [inputValue, setInputValue] = useState(
    record.parameterInputValue || ""
  );

  const handleToggle = () => {
    setIsSelect((prev) => !prev);
  };

  const handleSelectChange = (value) => {
    handleDataChange(value, record, "reportedParameter");
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleInputBlur = () => {
    handleDataChange(inputValue, record, "reportedParameter", true);
  };

  const handleInputKeyDown = (e) => {
    if (e.key === "Enter") {
      handleDataChange(inputValue, record, "reportedParameter", true);
    }
  };

  if (!record.reportedParameter) {
    const options = getParameterOptions();
    return (
      <div
        style={{ display: "flex", alignItems: "center", gap: 4, width: "100%" }}
      >
        {userRole !== "lab_admin" && userRole !== "support_team" && userRole !== "csc_admin"  ? (
  isSelect ? (
    <Select
      style={{ flex: 1 }}
      value={record.reportedParameter || undefined}
      placeholder="Select Parameter"
      onChange={handleSelectChange}
      options={options}
    />
  ) : (
    <Input
      style={{ flex: 1 }}
      placeholder="Enter Reported Parameter"
      value={inputValue || ""}
      onChange={handleInputChange}
      onBlur={handleInputBlur}
      onKeyDown={handleInputKeyDown}
    />
  )
) : ([]
)}
        {userRole !== "lab_admin" && userRole !== "support_team" && userRole !== "csc_admin" && (
          <Tooltip title="Change Field">
            <SwapOutlined
              onClick={handleToggle}
              style={{
                cursor: "pointer",
                transform: isSelect ? "rotate(0deg)" : "rotate(180deg)",
                transition: "transform 0.3s",
              }}
            />
          </Tooltip>
        )}
      </div>
    );
  } else {
    return (
      <Paragraph style={{ width: "100%", margin: 0 }}>
        {record.reportedParameter}
      </Paragraph>
    );
  }
};

export default ReportedParameterCell;
